import React from 'react'
import { Link, hashHistory } from 'react-router'
import { logoutUser, getToken } from '../Commons/Authentication'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import SicorLogoColor from '../../img/logos/color_logo.png'
import { ToastContainer, ToastMessage } from 'react-toastr'
import DoctorIcon from '../../img/icons/general-icons/doctor_icon.png'
import OptionLine from '../../img/icons/general-icons/separator_icon.png'
import store from './store'
// const store = createStore(reducer);

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class NavigationBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = ({ user: null })
  }

  cerrarSesion(e) {
    e.preventDefault()
    logoutUser()
    hashHistory.push('/')
  }

  componentWillMount() {
    this.loadUserData()
  }

  loadUserData() {

    let endpoint = 'api/v1/user/find'
    request
      .get(endpoint)
      .set('Authorization', `Bearer ${getToken()}`)
      .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) console.log('nologueado')
        else {
          if (res.body.nombrecompleto !== '' && res.body.nombrecompleto !== undefined) {
            const action = {
              type: 'add_to_array',
              payload: res.body
            }
            store.dispatch(action)
            localStorage.rol_name = res.body.rol[0].nombre
            this.setState({ user: res.body.nombrecompleto, rol: res.body.rol[0].nombre, rolLabel: res.body.rol[0].label })
          } else {
            this.setState({ user: res.body.email, rol: res.body.rol[0].nombre, rolLabel: res.body.rol[0].label })
          }
        }
      })
  }

  searchRedirect() {
    hashHistory.push('search')
  }

  searchTypeRedirect() {
    hashHistory.push('/searchType')
  }

  searchEPSRedirect() {
    hashHistory.push('/searchEps')
  }

  searchGroupRedirect() {
    hashHistory.push('/searchGroup')
  }

  cancelFunction(e) {
    e.preventDefault()
    if (this.props.dirty === true) {
      this.refs.container.warning(<span className='center-content'>Tiene cambios pendientes ¿Desea abandonar el formulario de todos modos? <br /><br /><span className='email-validation-container'><button type='button' className='btn btn-confirm clear' onClick={this.searchRedirect.bind(this)}>Si</button><button type='button' className='btn btn-confirm clear'>No</button></span></span>, <em>Tiene cambios pendientes</em>, {
        closeButton: true,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': 0,
        'extendedTimeOut': 0,
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
      })
    } else {
      this.searchRedirect()
    }
  }

  render() {
    // console.log(store)
    return (
      <div className='header-navigation-menu'>
        <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
        <div className='navigation-bar'>
          <div className='navigation-conatiner'>
            <img className='nav-logo-container' src={SicorLogoColor} />
            <img className='nav-user-icon' src={DoctorIcon} />
            <span className='nav-welcome-user'>Bienvenido&#40;a&#41;, {this.state.user}  [<strong>{this.state.rolLabel}</strong>]</span>
          </div>
          <div className='navigation-menu-container'>
            {(this.state.rol === 'admin') ? <ul className='menu'>
              <span>Administración</span>
              <Link to={'/searchUser'}><li className='item'>Usuarios</li></Link>
              <Link to={'/reportes'}><li className='item'>Reportes</li></Link>
              <Link to={'/searchEps'}><li className='item'>EPS</li></Link>
              <Link to={'/searchGroup'}><li className='item'>Grupos</li></Link>
              <Link to={'/searchType'}><li className='item'>Tipos</li></Link>
            </ul> : ''}
            <img className='navigation-menu-icon' src={OptionLine} />
            <div className='navigation-option' onClick={this.cancelFunction.bind(this)}>Listado</div>
            <img className='navigation-menu-icon' src={OptionLine} />
            <div className='navigation-option' onClick={this.cerrarSesion.bind(this)} >Cerrar sesión</div>
          </div>
        </div>
      </div>
    )
  }
}

NavigationBar.propTypes = {
  dirty: React.PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/Commons/NavigationBar.js